import axios from "axios";
import React from "react";
import config from '../../config';
import { headers } from "../../token";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";

const DeleteMouldAuth = async (MouldFileID, getMouldLibrary) => {
    const server_backend = config.API_URL;
    try {
        const response = await axios.post(`${server_backend}/files/moulds/public/delete`, {
            id: MouldFileID
        }, headers);

        if (response.data.RES_CODE === "00") {
            if (getMouldLibrary) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: "Success.",
                    showConfirmButton: false,
                    timer: 1000
                })
                getMouldLibrary();
            }

        } else if (response.data.StatusCode === 200) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.data.StatusMessage,
                showConfirmButton: false,
                timer: 1000
            });
        }

    } catch (error) {
        const message = validateError(error);

        Swal.fire({
            icon: 'error',
            title: message,
            showConfirmButton: false,
            timer: 2000
        });
    }

};
export default DeleteMouldAuth;